export default __webpack_public_path__ + "static/821-1353e35d1b09fc2da771107704ae7d09.gif";